export const isDev = process.env.NODE_ENV === 'development';

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const API_URL = `${BASE_URL}/api`;

export const PUBLIC_URL = process.env.PUBLIC_URL;

export const IMAGE_URL = 'https://community.fastly.steamstatic.com/economy/image';

export const CASE_IMAGE_URL = `${BASE_URL}/assets/img/cases`;

export const devHeaders = {
	'CF-Access-Client-Id': process.env.REACT_APP_CF_ACCESS_CLIENT_ID || '',
	'CF-Access-Client-Secret': process.env.REACT_APP_CF_ACCESS_CLIENT_SECRET || '',
};

export const EVENT_AWARD_TYPES = {
	COINS: 'COINS',
	CASE: 'CASE',
};

export const TASKS_CLASSES = {
	AVAILABLE: 'available',
	CHECKED: 'checked',
	DISABLED: 'disabled',
};
